<template>
  <div class="ks-box">
    <div class="ks-box__title" v-if="title">{{title}}</div>
    <slot />
  </div>
</template>
<script>
export default {
  name:'Box',
  props:{
    title:String
  }
}
</script>
<style scoped>
.ks-box{
  margin: 10px 10px 0 10px;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
}
.ks-box__title{
      font-size: 16px;
      line-height:22px;
      font-weight:bolder;
      color:rgba(51,51,51,1);
      margin-top:13px;
}
</style>




// WEBPACK FOOTER //
// src/ks-components/Box.vue